import { FC, ReactNode } from 'react'
import { Box, SelectProps } from '@mui/material'
import theme from 'theme'

interface Props extends SelectProps {
  children: ReactNode
}

const ErrorWrapper: FC<Props> = ({ children }) => {
  return (
    <Box
      sx={{
        marginTop: `${theme.spacing.small}px`,
        color: theme.colors.errorLight,
        '& p': {
          color: 'inherit'
        }
      }}
    >
      {children}
    </Box>
  )
}

export default ErrorWrapper
